<template>
	<div class="table is-fullwidth">
		<tr>
			<td>Monthly rent</td>
			<td class="has-text-right">{{ $store.state.evaluation.calculator.conventionalMonthlyRent | currency(0) }}</td>
		</tr>
		<tr>
			<td>Note payment</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.conventionalNotePaymentMonthly * -1) | currency(0) }}</td>
		</tr>
		<tr>
			<td>Property tax</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.conventionalPropertyTaxMonthly *-1)| currency(0) }}</td>
		</tr>
		<tr>
			<td>Property ins</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.conventionalPropertyInsuranceMonthly * -1) | currency(0) }}</td>
		</tr>
		<tr>
			<td>Mortgage ins</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.conventionalMortgageInsuranceMonthly * -1) | currency(0) }}</td>
		</tr>
		<tr>
			<td>HOA</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.conventionalHoaMonthly * -1) | currency(0) }}</td>
		</tr>
		<tr>
			<td>Misc monthly</td>
			<td class="has-text-right">{{ ($store.state.evaluation.calculator.conventionalMiscellaneousMonthly * -1) | currency(0) }}</td>
		</tr>
		<tr>
			<td class="has-text-weight-semibold">TOTAL</td>
			<td class="has-text-right has-text-weight-semibold">{{ $store.state.evaluation.calculator.conventionalTotalCashflowMonthly | currency(0) }}</td>
		</tr>
	</div>
</template>

<script>
import store from "@/store";

export default {
  components: {
    store
  }
};
</script>
